import { Component, Input, OnInit, OnChanges, SimpleChanges } from '@angular/core';
import { NgClass } from '@angular/common';

@Component({
  selector: 'app-alert',
  imports: [NgClass],
  templateUrl: './alert.component.html',
  styleUrl: './alert.component.css'
})
export class AlertComponent implements OnInit, OnChanges {
  @Input() title: string = 'Notificación';
  @Input() message: string = 'Mensaje de alerta';
  @Input() type: 'success' | 'alert' = 'success';
  @Input() duration: number = 4000;
  visible: boolean = false;

  get bgColor(): string {
    return this.type === 'success' 
      ? 'bg-green-500' 
      : 'bg-red-500';
  }

  get textColor(): string {
    return this.type === 'success'
      ? 'text-green-700'
      : 'text-white';
  }

  ngOnInit() {
    this.visible = true;
    this.startHideTimer();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['message'] || changes['title'] || changes['type']) {
      this.visible = true;
      this.startHideTimer();
    }
  }

  private startHideTimer() {
    if (this.duration > 0) {
      setTimeout(() => {
        this.visible = false;
      }, this.duration);
    }
  }
}
